import { createActionConstants } from './actionsHelper';
export const UserActionTypes = {
  ...createActionConstants('LOGIN'),
  ...createActionConstants('LOGOUT'),
  ...createActionConstants('RESET_PASSWORD'),
  ...createActionConstants('UPDATE_PASSWORD'),
  ...createActionConstants('SIGNUP'),
  ...createActionConstants('RESEND_ACTIVATION')
};

export const userActions = {
  login,
  logout,
  resetPassword,
  updatePassword,
  signup,
  resendActivation
};

function login(credentionals) {
  return {
    type: UserActionTypes.LOGIN_REQUESTED,
    payload: { credentionals }
  };
}

function logout() {
  return {
    type: UserActionTypes.LOGOUT_REQUESTED
  };
}

function resetPassword(email, source_url) {
  return {
    type: UserActionTypes.RESET_PASSWORD_REQUESTED,
    payload: { email, source_url }
  };
}

function updatePassword(token, password) {
  return {
    type: UserActionTypes.UPDATE_PASSWORD_REQUESTED,
    payload: { token, password }
  };
}

function signup(user) {
  return {
    type: UserActionTypes.SIGNUP_REQUESTED,
    payload: { user }
  };
}

function resendActivation(email, source_url) {
  return {
    type: UserActionTypes.RESEND_ACTIVATION_REQUESTED,
    payload: { email, source_url }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/userActions.js